import { createSelector } from '@ngrx/store'

export const getPdfBatchGenerationState = createSelector(
  (state: any) => state.pdfBatchGeneration,
  (state: any) => state,
)
